import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  STAFFINTERFACE,
  TENANT_MODEL,
} from '@fitness-force/models';
import { ErrorsComponent,} from '@fitness-force/common/errors'
import { Store } from '@ngrx/store';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import {
  COMPANY_INFO,
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { StaffService } from 'libs/api/src/lib/staff.service';
import { ToastMessageService } from 'libs/api/src/lib/toastmessage/toastmessage.service';

@Component({
  selector: 'change-tenant-access',
  templateUrl: './change-tenant-access.component.html',
  styleUrls: ['./change-tenant-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    StyleClassModule,
    MultiSelectModule,
    ErrorsComponent,
    TranslateModule
]
})
export class ChangeTenantAccessComponent implements OnInit {
  @Input('visible') changeTenantAccesDialog: boolean = false;
  @Input('staff') staff: STAFFINTERFACE = {} as STAFFINTERFACE;
  @Output('closePopup') closePopup = new EventEmitter();

  accessTenant$ = new BehaviorSubject([] as TENANT_MODEL[]);
  formGroup: UntypedFormGroup = new UntypedFormGroup({});
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;

  constructor(
    private fb: UntypedFormBuilder,
    public translate: TranslateService,
    private store: Store,
    private staffService: StaffService,
    private toastMessageService: ToastMessageService
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.ComponentInit();
  }

  createForm(): void {
    this.formGroup = this.fb.group({
      new_tenant_access: new UntypedFormControl([], [Validators.required]),
    });

    this.formGroup.controls.new_tenant_access.valueChanges.subscribe(
      (staff: STAFFINTERFACE) => {
        console.log(staff);
      }
    );
  }

  ComponentInit() {
    this.store.select(COMPANY_INFO).subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    this.store.select(TENANTS_INFO).subscribe((tenant) => {
      this.accessTenant$.next(tenant.accessed_tenant);

      let accesTenant: TENANT_MODEL[] = tenant.accessed_tenant.filter(
        (t: TENANT_MODEL) => {
          return this.staff.tenant_access_id.includes(t.id);
        }
      );

      this.formGroup.controls.new_tenant_access.setValue(accesTenant);
    });
  }

  

  ClosePopup(): void {
    this.changeTenantAccesDialog = false;
    this.formGroup.reset();
    this.closePopup.emit();
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
  }

  get NEWTENANTACCESSCONTROL(): UntypedFormControl {
    return this.formGroup.controls.new_tenant_access as UntypedFormControl;
  }

  get NEWTENANTACCESS(): number[] {
    let tenants = this.formGroup.controls.new_tenant_access.value;
    return tenants.map((t: any) => t.id);
  }

  ValidateAndSubmit(): void {
    if (this.formGroup.valid) {
      let staffId = this.staff.id;
      this.staffService
        .ChangeTenantAccess(environment.BASE_URL, staffId, this.NEWTENANTACCESS)
        .subscribe({
          next: (data: any) => {
            console.log(data);
            this.translate
              .get('common.message.record_updated')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            this.store.dispatch({ type: 'FETCH_STAFF_LIST' });
            this.ClosePopup();
          },
          error: (error: any) => {
           this.toastMessageService.showError(error);
          },
        });
    }
  }
}

